import { Container, Typography } from "@material-ui/core"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import styled from "styled-components"
import { HEADER_HEIGHT_D, HEADER_HEIGHT_M } from "theme/shared"
import ImageContainer from "./ImageContainer"

const StyledPageWrapper = styled.div`
  display: flex;
  padding-top: ${HEADER_HEIGHT_M}px;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.lightGrey};
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-top: ${HEADER_HEIGHT_D}px;
  }
`
const StyledPageWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const StyledContentWrap = styled(Container)`
  display: flex;
  margin-bottom: 60px;
  flex-direction: column;
  width: 100%;
  padding-right: 20px;
  padding-left: 20px;
  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
  }
`
const StyledHeader = styled(Container)<{ $paddingBottom?: string }>`
  padding: 40px 20px;
  padding-bottom: ${(p) => `${p.$paddingBottom && p.$paddingBottom}px`};
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 40px 20px 20px;
    max-width: 800px;
    padding-bottom: ${(p) =>
      `${p.$paddingBottom && p.$paddingBottom}px !important`};
  }
`
const StyledHeadline = styled(Typography).attrs({
  variant: "h2",
  component: "h1",
})`
  text-align: right;
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: center;
  }
`
const StyledSubtitle = styled(Typography)`
  text-align: right;
  margin-top: 10px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 20px;
    text-align: center;
  }
`
type InnerPageWrapperProps = {
  imgUrl: string
  title?: string
  subtitle?: string
  children: React.ReactNode
  breadCrumbName?: string
  page?: string
  paddingBottom?: string
  className?: string
}

const InnerPageWrapper = ({
  imgUrl,
  title,
  subtitle,
  children,
  breadCrumbName,
  page,
  paddingBottom,
  className,
}: InnerPageWrapperProps) => {
  return (
    <StyledPageWrapper className={className}>
      <StyledPageWrap>
        <ImageContainer src={imgUrl} />
        <BreadCrumbsWrapper name={breadCrumbName} page={page} />
        {title && (
          <StyledHeader $paddingBottom={paddingBottom}>
            <StyledHeadline> {title} </StyledHeadline>
            {subtitle && (
              <StyledSubtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
            )}
          </StyledHeader>
        )}

        <StyledContentWrap>{children}</StyledContentWrap>
      </StyledPageWrap>
    </StyledPageWrapper>
  )
}

export default InnerPageWrapper
